export default "__VITE_ASSET__Cpki2_qC__"